/** User-created tile definitions are appended here by the tile editor. */
export const CUSTOM_TILES = [];
